import { queryOptions } from '@tanstack/react-query'

import Client from '@/api/client'
import { getConfig } from '@/app/config'

const client = new Client(getConfig().API_ENDPOINT ?? '')

export const WEBSOCKET_ENTITY_TYPES = ['booking', 'shipment', 'customer'] as const
export type WebsocketEntityType = (typeof WEBSOCKET_ENTITY_TYPES)[number] | (string & {})

const getSocketToken = (referenceID: string, type: WebsocketEntityType) => {
  return client.post<{ token: string }>(`/api/subscriptions/websockets/generate-token`, {
    type,
    referenceID,
  })
}

export const socketTokenQueryOptions = (entity: { referenceId: string; type: WebsocketEntityType }, enabled = true) =>
  queryOptions({
    queryKey: ['socketToken', entity.type, entity.referenceId],
    queryFn: () => getSocketToken(entity.referenceId, entity.type),
    enabled,
    // Stale time is set to 24 hours so it only refreshes the token once a day, token is valid for a week
    staleTime: 24 * 60 * 60 * 1000,
  })
